import PropTypes from 'prop-types'
import { LocationInfo } from './LocationInfo'
import PrimaryButton from '../buttons/PrimaryButton'
import {
  CareerPageArticle,
  CareerPageButtonWrapper,
  CareerPageHeader,
  CareerPageJobHeaderCompanyName,
  CareerPageJobHeaderDetails,
  CareerPageJobHeaderPlaceholderLogo,
  CareerPageJobHeaderSection,
  CareerPageJobHeaderTitle,
  CareerPageLogoImage,
  CareerPageLogoWrapper,
} from '../styled'
import { useTranslation } from 'react-i18next'

export function JobHeader({
  companyName,
  logoUrl,
  city,
  country,
  workplaceType,
  employmentType,
  title,
  invitationLink,
  easyApplyLink,
  getInitials,
}) {
  const { t } = useTranslation()

  const applicationLink = easyApplyLink || invitationLink
  const isEasyApply = !!easyApplyLink

  return (
    <CareerPageJobHeaderSection>
      <CareerPageArticle>
        <CareerPageHeader>
          <CareerPageLogoWrapper>
            {logoUrl ? (
              <CareerPageLogoImage
                loading="lazy"
                src={logoUrl}
                alt="company logo"
              />
            ) : (
              <CareerPageJobHeaderPlaceholderLogo>
                {getInitials(companyName)}
              </CareerPageJobHeaderPlaceholderLogo>
            )}
          </CareerPageLogoWrapper>
          <CareerPageJobHeaderDetails>
            <CareerPageJobHeaderCompanyName>
              {companyName}
            </CareerPageJobHeaderCompanyName>
            <CareerPageJobHeaderTitle>{title}</CareerPageJobHeaderTitle>
            <LocationInfo
              city={city}
              country={country}
              workplaceType={workplaceType}
              employmentType={employmentType}
            />
          </CareerPageJobHeaderDetails>
        </CareerPageHeader>
        <CareerPageButtonWrapper>
          <PrimaryButton
            onClick={() =>
              window.open(`/job-application/${applicationLink}`, '_blank')
            }
            disabled={!applicationLink}
          >
            {isEasyApply ? t('careers.easyApply') : t('pages.apply')}
          </PrimaryButton>
        </CareerPageButtonWrapper>
      </CareerPageArticle>
    </CareerPageJobHeaderSection>
  )
}

JobHeader.propTypes = {
  companyName: PropTypes.string.isRequired,
  logoUrl: PropTypes.string,
  city: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  workplaceType: PropTypes.string.isRequired,
  employmentType: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  invitationLink: PropTypes.string,
  easyApplyLink: PropTypes.string,
  getInitials: PropTypes.func.isRequired,
}
